import { Flex, Tooltip } from '@mantine/core';

import DocumentationIcon from '@/assets/icons/content/file-alt-2-outline.svg';
import { POSTHOG_EVENTS } from '@/lib/posthog/events';
import { trackEvent } from '@/lib/posthog/helpers';

import classes from './Navbar.module.css';

const Documentation = ({ desktopOpened }: { desktopOpened: boolean }) => (
  <Flex
    align="center"
    wrap="nowrap"
    component="a"
    className={classes.footerNavRow}
    href="/docs/"
    target="_blank"
    aria-label="API Documentation"
    onClick={() => trackEvent(POSTHOG_EVENTS.API_DOCS_OPEN, { source: 'documentation_page' })}
  >
    <Tooltip
      arrowOffset={10}
      arrowSize={4}
      label="API Documentation"
      position="right"
      offset={40}
      color="var(--active-color)"
      disabled={desktopOpened}
      visibleFrom="sm"
      transitionProps={{ duration: 0 }}
      withArrow
    >
      <span className={classes.footerNavIcon}>
        <DocumentationIcon width={20} height={20} />
      </span>
    </Tooltip>

    <span className={classes.toggleLabel}>API Documentation</span>
  </Flex>
);

export default Documentation;
